import { useEffect, useState } from "react";
import "./ResponseDetailsMultiple.css";
import { FormResponseExtended, Question } from "effno-core";
import { Response } from "effno-core";
import { isEmptyJSON } from "../../utils/utils";

type ResponseDetailsMultipleProps = {
    question: Question | null;
    responses: FormResponseExtended[] | null;
}

export const ResponseDetailsMultiple = ({question, responses} : ResponseDetailsMultipleProps) => {

    let validResponses = 0;
    let currentResponses = 0;

    const settings = question ? JSON.parse(question.settings) : {}
    const choices = settings.choices || [];

    const responsesArray = new Array(choices.length).fill(0);

    if (responses) {
        responses.forEach((formResponse: FormResponseExtended)  => {
            formResponse.responses.forEach((response: Response) => {
                if (response.questionId === question?.id) {
                    const responseValues = JSON.parse(response.responseValues);

                    if (!isEmptyJSON(responseValues)) {

                        const responseChoices = responseValues.choices;
                        if (responseChoices && responseChoices.length > 0) {
                            validResponses++;
                            responseChoices.forEach((value: string) => {
                                const index = choices.indexOf(value);
                                if (index !== -1) {
                                    responsesArray[index] += 1;
                                    currentResponses++;
                                }
                            });
                        }
                    }
                }

            })
        });
    }

    console.log("[ResponseDetailsRating] choices: ", choices);
    console.log("[ResponseDetailsRating] responsesArray: ", responsesArray);

    const total = responses?.length || 0;

    return (
        <div className="response-details-multiple">
            <div className="response-details-multiple-header">
                <div className="response-details-multiple-stat">
                    Responses: {total}
                </div> 
                <div className="response-details-multiple-stat">
                    Current Responses: {currentResponses}
                </div> 
                <div className="response-details-multiple-stat">
                    Empty Responses: {total - validResponses}
                </div> 
            </div>

            {choices.map((choice: string, index: number) => {
                const percentage = Math.floor((responsesArray[index] / validResponses) * 100);

                return (
                    <div className="response-details-multiple-entry">
                        <div className="response-details-multiple-choice">
                            <div className="response-details-multiple-name">
                                {choice}
                            </div>
                            <div className="response-details-multiple-responses">
                                {"("}{responsesArray[index]} response{responsesArray[index] === 1 ? "" : "s"},
                            </div>
                            <div className="response-details-multiple-percentage">
                                {percentage.toFixed(1)}%{")"}
                            </div>
                        </div>
                        <div className="response-details-multiple-bar-container">
                            <div 
                                className="response-details-multiple-bar-value"
                                style={{width: `${percentage}%`}}
                            >
                                {}
                            </div>
                        </div>
                    </div>
                )
            })}

        </div>
    )
}